import React, { useContext, useEffect, useRef, useState } from 'react';
import { SFuncModal } from 'shj-components'
import {
  Form,
  Button,
  message,
  Table,
  Input,
  InputNumber,
} from 'antd';
import { modalAddOrSelectFn } from './select';
import { addVerifyApplyForHandle } from '@/services/fmsServices'
import type { GetRef, InputRef, TableProps } from 'antd';
import dayjs from 'dayjs';
import styles from '../index.module.less'
// @ts-ignore
export function OnWriteOff({ fn, ...rest }) {
  const onClose = () => {
    dialog.destroy();
  };

  const dialog = SFuncModal({
    title: `${rest.sourceBillType==='verifySourceTypeReceipt'? '收款核销处理':'应收核销处理'}`,
    width: 900,
    vanish: true,
    content: <ModalAddOrEditDom onClose={onClose} fn={fn} {...rest} />,
  });

  return dialog;
}

type FormInstance<T> = GetRef<typeof Form<T>>;

const EditableContext = React.createContext<FormInstance<any> | null>(null);

interface Item {
  key: string;
  name: string;
  age: string;
  address: string;
}

interface EditableRowProps {
  index: number;
}
const EditableRow: React.FC<EditableRowProps> = ({ index, ...props }) => {
  const [form] = Form.useForm();
  return (
    <Form form={form} component={false}>
      <EditableContext.Provider value={form}>
        <tr {...props} />
      </EditableContext.Provider>
    </Form>
  );
};

interface EditableCellProps {
  title: React.ReactNode;
  editable: boolean;
  dataIndex: keyof Item;
  record: any;
  handleSave: (record: Item) => void;
}

const EditableCell: React.FC<React.PropsWithChildren<EditableCellProps>> = ({
  title,
  editable,
  children,
  dataIndex,
  record,
  handleSave,
  ...restProps
}) => {
  const [editing, setEditing] = useState(false);
  const inputRef = useRef<InputRef>(null);
  const form = useContext(EditableContext)!;

  useEffect(() => {
    if (editing) {
      inputRef.current?.focus();
    }
  }, [editing]);

  const toggleEdit = () => {
    setEditing(!editing);
    form.setFieldsValue({ [dataIndex]: record[dataIndex] });
  };

  const save = async () => {
    try {
      const values = await form.validateFields();
      values.verifiedAmount = Math.abs(values.verifiedAmount) * (record?.canVerifyAmount >= 0 ? 1 : -1)
      toggleEdit();
      handleSave({ ...record, ...values });
    } catch (errInfo) {
      console.log('Save failed:', errInfo);
    }
  };

  let childNode = children;

  if (editable) {
    childNode = editing ? (
      <Form.Item
        style={{ margin: 0 }}
        name={dataIndex}
        rules={[{ required: true, message: `不能为空` }]}
      >
        <InputNumber ref={inputRef} onPressEnter={save} onBlur={save} />
      </Form.Item>
    ) : (
      <div
        className={styles.editableCellValueWrap}
        style={{ paddingInlineEnd: 24 }}
        onClick={toggleEdit}
      >
        {children}
      </div>
    );
  }

  return <td {...restProps}>{childNode}</td>;
};

interface DataType {
  id: React.Key;
  name: string;
  age: string;
  address: string;
}

const ModalAddOrEditDom = ({ onClose, fn, ...rest }) => {
  const [form] = Form.useForm();
  const [addOrEditFooterLoading, setAddOrEditFooterLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [datas, setData] = useState([] as any[]);
  console.log(rest,'ssss')
  const defaultColumns = [
    {
      title: '单据类型',
      dataIndex: 'sourceBillTypeName',
      width: '20%',
    },
    {
      title: '单据类型code',
      dataIndex: 'sourceBillType',
      hidden: true,
    },
    {
      title: '单据号',
      dataIndex: 'sourceCode',
      width: '20%',
    },
    {
      title: '交易/收款类型',
      dataIndex: 'sourceTypeName',
      width: '20%',
    },
    {
      title: '交易/收款类型code',
      dataIndex: 'sourceType',
      hidden: true,
    },
    {
      title: '可核销金额',
      dataIndex: 'canVerifyAmount',
      width: '20%',
    },
    {
      title: '本次核销金额',
      dataIndex: 'verifiedAmount',
      width: '20%',
      editable: true,
    },
  ];

  // 新增
  const add = () => {
    rest.datas = datas
    modalAddOrSelectFn({
      fns: (v: any[]) => {
        setData((prevData) => [...prevData, ...v]);
      },
      ...rest,
    });
  };
  const openModel = () => {
    add();
  };
  const subClick = () => {
    let addData = {
      orderAccountId: rest.orderAccountId,
      verifyType: rest.sourceBillType === 'verifySourceTypeReceipt' ? rest.amount > 0 ? 'verifyTypePosReceipt':'verifyTypeNegReceipt' : rest.receivableAmount > 0 ? 'verifyTypePosReceiptApply':'verifyTypeNegReceiptApply',
      billId: rest.id,
      verifyAmount: total,
      verifyApplyDtlList: datas
    }
    setAddOrEditFooterLoading(true);
    addVerifyApplyForHandle(addData).then((response: any) => {
      setAddOrEditFooterLoading(false);
      message.info(response?.message || '操作成功');
      onClose();
      fn && fn();
    }).finally(() => {
        setAddOrEditFooterLoading(false);
    });
  };
  const columns = defaultColumns.map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record: DataType) => ({
        record,
        editable: col.editable,
        dataIndex: col.dataIndex,
        title: col.title,
        handleSave,
      }),
    };
  });
  const handleSave = (row: any) => {
    const newData = [...datas];
    const index = newData.findIndex((item) => row.sourceId === item.sourceId);
    const item = newData[index];
    newData.splice(index, 1, {
      ...item,
      ...row,
    });
    // 计算 verifiedAmount 的合计
    const totalVerifiedAmount = newData.reduce((total, item) => total + (Math.abs(item.verifiedAmount) || 0), 0);
    setTotal(Math.abs(totalVerifiedAmount) * (rest?.unverifiedAmount >= 0 ? 1 : -1));  // 更新合计
    setData(newData);
  };
  return (
    <div style={{ padding: '15px' }}>
      <div style={{display: 'flex', justifyContent: 'space-between'}}>
        <Button
          type="primary"
          htmlType="submit"
          style={{ marginBottom: '20px' }}
          onClick={() => openModel()}
        >
          选择单据
        </Button>
        <div>{rest.sourceBillType==='verifySourceTypeReceipt'?'收款':'应收'}未核销金额：{rest?.unverifiedAmount}</div>
      </div>
      <Form form={form} component={false}>
        <Table
          components={{
            body: {
              row: EditableRow,
              cell: EditableCell,
            },
          }}
          size='small'
          rowKey="sourceId"
          bordered
          dataSource={datas}
          columns={columns}
          rowClassName={() => styles.editableRow}
          pagination={false}
          summary={() => (datas.length !== 0 ?
            <React.Fragment>
              <Table.Summary fixed>
                <Table.Summary.Row>
                  <Table.Summary.Cell index={0}>-</Table.Summary.Cell>
                  <Table.Summary.Cell index={1}>合计</Table.Summary.Cell>
                  <Table.Summary.Cell index={2}>-</Table.Summary.Cell>
                  <Table.Summary.Cell index={3}>-</Table.Summary.Cell>
                  <Table.Summary.Cell index={4}><span style={{paddingLeft: 12}}>{total}</span></Table.Summary.Cell>
                </Table.Summary.Row>
              </Table.Summary>
            </React.Fragment>
          :null)}
        />
      </Form>
      <div style={{ textAlign: 'right' }}>
        <Button
          disabled={datas.length != 0 ? false : true}
          type="primary"
          htmlType="submit"
          style={{ margin: '10px' }}
          loading={addOrEditFooterLoading}
          onClick={() => subClick()}
        >
          确认核销
        </Button>
      </div>
    </div>
  );
};
